import { createFeatureSelector, createSelector } from '@ngrx/store'
import { ISubcontractShowState } from './subcontract-show.reducer'
import { StoreKeysEnum } from '../../../../../store/store-keys'
import { toDisplayUnits } from '../../../../../shared/utils/month-year-unit'

export const selectSubcontractShowFeature = createFeatureSelector<Readonly<ISubcontractShowState>>(StoreKeysEnum.SubcontractShowComponent)

export const selectSubcontractShowContract = createSelector(
    selectSubcontractShowFeature,
    feature => (feature.contract),
)
export const selectSubcontractShowParcels = createSelector(
    selectSubcontractShowFeature,
    feature => (feature.parcels),
)
export const selectSubcontractShowSameLVAndKatuze = createSelector(
    selectSubcontractShowFeature,
    feature => (feature.sameLVAndKatuze),
)
export const selectSubcontractShowIsAppendix = createSelector(
    selectSubcontractShowFeature,
    feature => (feature.isAppendix),
)
export const selectSubcontractShowParcelsOrder = createSelector(
    selectSubcontractShowFeature,
    feature => (feature.parcelsOrder),
)
export const selectSubcontractShowLvInfo = createSelector(
    selectSubcontractShowParcels,
    selectSubcontractShowSameLVAndKatuze,
    (parcels, sameLVAndKatuze) => {
        if (sameLVAndKatuze && parcels?.length) {
            return parcels[0].katuzeNazev + ', LV ' + parcels[0].lv
        } else {
            return null
        }
    },
)
export const selectSubcontractShowAttachments = createSelector(
    selectSubcontractShowFeature,
    feature => (feature.attachments),
)
export const selectSubcontractShowAttachmentsLoading = createSelector(
    selectSubcontractShowFeature,
    feature => (feature.attachmentsLoading),
)
export const selectSubcontractShowAttachmentsState = createSelector(
    selectSubcontractShowAttachments,
    selectSubcontractShowAttachmentsLoading,
    (attachments, attachmentsLoading) => ({
        attachments,
        attachmentsLoading,
    }),
)
export const selectSubcontractShowRelatedContracts = createSelector(
    selectSubcontractShowFeature,
    feature => (feature.relatedContracts),
)
export const selectSubcontractShowSignatureDocuments = createSelector(
    selectSubcontractShowFeature,
    feature => (feature.signatureDocuments),
)
export const selectSubcontractShowSignatureDocumentsGroup = createSelector(
    selectSubcontractShowFeature,
    feature => (feature.signatureDocumentsGroup),
)
export const selectSubcontractShowDocumentsState = createSelector(
    selectSubcontractShowRelatedContracts,
    selectSubcontractShowSignatureDocuments,
    selectSubcontractShowSignatureDocumentsGroup,
    selectSubcontractShowContract,
    selectSubcontractShowAttachments,
    selectSubcontractShowAttachmentsLoading,
    (relatedContracts, signatureDocuments, signatureDocumentsGroup, contract, attachments, attachmentsLoading) => ({
        relatedContracts,
        signatureDocuments,
        signatureDocumentsGroup,
        owners: contract.owners,
        contractId: contract.id,
        payoutToId: undefined,
        groupId: contract.groupId,
        createIndividualDocuments: contract.createIndividualDocuments,
        canAddDocuments: true,
        attachments,
        attachmentsLoading,
    }),
)
export const selectSubcontractShowEndDialogState = createSelector(
    selectSubcontractShowContract,
    (contract) => ({
        object: contract,
        efficiencyFromDate: contract.signatureDate,
        endType: contract.endType,
        endDate: contract.endDate,
        resignDate: contract.resignDate,
        expirationDate: contract.expirationDate,
    })
)
export const selectSubcontractShowContractOwners = createSelector(
    selectSubcontractShowContract,
    contract => (contract.owners)
)
export const selectSubcontractShowContractOwnersLength = createSelector(
    selectSubcontractShowContract,
    contract => (contract.owners?.length)
)
export const selectSubcontractShowContractToEconomicYear = createSelector(
    selectSubcontractShowContract,
    contract => (contract.toEconomicYear)
)
export const selectSubcontractShowContractNoticePeriod = createSelector(
    selectSubcontractShowContract,
    contract => ({
        noticePeriodMonths: toDisplayUnits(contract?.noticePeriodMonths, contract?.noticePeriodMonthsUnit),
        noticePeriodMonthsUnit: contract.noticePeriodMonthsUnit,
        indefinite: contract?.indefinite,
    })
)
export const selectSubcontractShowContractVersionType = createSelector(
    selectSubcontractShowContract,
    contract => (contract.versionType)
)
export const selectSubcontractShowContractSignatureDate = createSelector(
    selectSubcontractShowContract,
    contract => (contract.signatureDate)
)

export const selectSubcontractShowDurationPeriodState = createSelector(
    selectSubcontractShowContract,
    (contract) => ({
        indefinite: contract.indefinite,
        reusedPreviousExpiration: contract.reusedPreviousExpiration,
        durationMonths: toDisplayUnits(contract?.durationMonths, contract?.durationMonthsUnit),
        durationMonthsUnit: contract.durationMonthsUnit,
        durationToDate: contract.durationToDate,
    })
)

export const selectSubContractShowOptionalOptions = createSelector(
    selectSubcontractShowContract,
    (contract) => ({
        furtherRentPossible: contract.furtherRentPossible,
        reqNewAppendixAfterReprice: contract.reqNewAppendixAfterReprice,
        tenantHasPreemption: contract.tenantHasPreemption,
    })
)

export const selectSubcontractShowNoteState = createSelector(
    selectSubcontractShowContract,
    (contract) => ({
        objectId: contract.id,
        note: contract.note
    })
)

export const selectSubcontractShowPaymentsFromEconomicYear = createSelector(
    selectSubcontractShowContract,
    contract => (contract.paymentsFromEconomicYear),
)